import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";

export function useResendVerificationMutation() {
  return useMutation({ mutationFn: authApi.resendVerification });
}
